/**
 * 아이콘.
 *
 * 아이콘 폰트나 외부 패키지를 쓰지 않습니다 — 웹뷰는 네트워크가 불안정할 수 있고,
 * 아이콘 폰트가 늦게 뜨면 탭바가 빈 채로 보입니다. 인라인 SVG 는 그런 일이 없습니다.
 */
export type IconName =
  | 'partner'
  | 'book'
  | 'home'
  | 'diary'
  | 'room'
  | 'filter'
  | 'plus'
  | 'menu'
  | 'search'
  | 'userPlus'
  | 'close'
  | 'back'
  | 'forward'
  | 'more'
  | 'share'
  | 'star'
  | 'block'
  | 'trash'
  | 'check'
  | 'mic'
  | 'verse'
  | 'doc'
  | 'pencil'
  | 'exit'
  | 'image'
  | 'tiles';

const paths: Record<IconName, React.ReactNode> = {
  partner: (
    <>
      <circle cx="9.2" cy="8" r="3.3" />
      <path d="M3 19.6c0-3.4 2.8-5.6 6.2-5.6s6.2 2.2 6.2 5.6" />
      <path d="M16.4 5.2a3 3 0 0 1 0 5.7" />
      <path d="M18 14.4c2 .7 3.2 2.5 3.2 5.2" />
    </>
  ),
  book: (
    <>
      <path d="M12 6.6S10.4 5.1 7.4 5.1H3.6v13.4h4c3 0 4.4 1.5 4.4 1.5s1.4-1.5 4.4-1.5h4V5.1h-3.8C13.6 5.1 12 6.6 12 6.6z" />
      <path d="M12 6.6v13.4" />
    </>
  ),
  home: (
    <>
      <path d="M3.2 10.6 12 3.4l8.8 7.2" />
      <path d="M5.6 9.6V20.4h12.8V9.6" />
      <path d="M9.8 20.4v-5.6h4.4v5.6" />
    </>
  ),
  diary: (
    <>
      <rect x="3.6" y="5.4" width="16.8" height="15" rx="2.4" />
      <path d="M3.6 10h16.8" />
      <path d="M8.4 3.4v4M15.6 3.4v4" />
    </>
  ),
  room: (
    <>
      <path d="M3.4 5.6h11.2v7.6H7.9L3.4 16.6v-3.4z" />
      <path d="M9.4 16.6h5.4l4.5 3.4v-3.4h1.3V9.6h-2.6" />
    </>
  ),
  filter: <path d="M4 6.5h16M7 12h10M10 17.5h4" />,
  plus: <path d="M12 5v14M5 12h14" />,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  search: (
    <>
      <circle cx="10.8" cy="10.8" r="6.4" />
      <path d="m15.6 15.6 4.4 4.4" />
    </>
  ),
  userPlus: (
    <>
      <circle cx="10" cy="8" r="3.4" />
      <path d="M3.6 19.6c0-3.4 2.9-5.6 6.4-5.6 1 0 2 .2 2.8.5" />
      <path d="M17.6 14v6M14.6 17h6" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  back: <path d="M15 5l-7 7 7 7" />,
  forward: <path d="M9 5l7 7-7 7" />,
  more: (
    <>
      <circle cx="12" cy="5.4" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="18.6" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  share: (
    <>
      <path d="M12 15.4V3.6" />
      <path d="M8 7.4 12 3.4l4 4" />
      <path d="M5 13v7.4h14V13" />
    </>
  ),
  star: <path d="m12 3.6 2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.8l5.9-.8z" />,
  block: (
    <>
      <circle cx="12" cy="12" r="8.2" />
      <path d="m6.2 6.2 11.6 11.6" />
    </>
  ),
  trash: (
    <>
      <path d="M4.6 6.6h14.8" />
      <path d="M8.6 6.6V4.4h6.8v2.2" />
      <path d="M6.6 6.6 7.6 20h8.8l1-13.4" />
    </>
  ),
  check: <path d="m5 12.5 4.6 4.6L19 7.5" />,
  mic: (
    <>
      <rect x="9.2" y="3.2" width="5.6" height="11" rx="2.8" />
      <path d="M6 11.4a6 6 0 0 0 12 0" />
      <path d="M12 17.4v3.4" />
    </>
  ),
  verse: <path d="M6.5 4.5h11v15l-5.5-3.3L6.5 19.5z" />,
  doc: (
    <>
      <path d="M6 3.6h8l4 4v12.8H6z" />
      <path d="M14 3.6v4h4" />
      <path d="M9 12.6h6M9 16h4" />
    </>
  ),
  /* 모임 기록지가 쓰는 넷 — 줄 수정 · 나가기 · 사진첩 · 기본 사진 */
  pencil: (
    <>
      <path d="M4.6 19.4 5.5 15.3 15.7 5.1 18.9 8.3 8.7 18.5z" />
      <path d="m13.7 7.1 3.2 3.2" />
    </>
  ),
  exit: (
    <>
      <path d="M10.2 4.6H5.6v14.8h4.6" />
      <path d="M14.6 8.2 18.4 12l-3.8 3.8" />
      <path d="M18.2 12H9.6" />
    </>
  ),
  image: (
    <>
      <rect x="3.6" y="4.6" width="16.8" height="14.8" rx="2.4" />
      <circle cx="9" cy="10" r="1.7" />
      <path d="m4.4 17.8 5.2-5.2 3.6 3.6 2.6-2.6 4.2 4.2" />
    </>
  ),
  tiles: (
    <>
      <rect x="4" y="4" width="7" height="7" rx="1.6" />
      <rect x="13" y="4" width="7" height="7" rx="1.6" />
      <rect x="4" y="13" width="7" height="7" rx="1.6" />
      <rect x="13" y="13" width="7" height="7" rx="1.6" />
    </>
  ),
};

interface Props {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 24 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {paths[name]}
    </svg>
  );
}
